import { FormGroup } from '@angular/forms';

/**
 * Utility functions for form validation and manipulation
 */

/**
 * Mark all controls in the provided form group as touched to trigger validation messages.
 * This is useful for displaying validation errors when a user attempts to submit an invalid form.
 *
 * @param form The FormGroup to mark as touched
 */
export function markFormGroupTouched(form: FormGroup): void {
  Object.keys(form.controls).forEach(key => {
    form.get(key)?.markAsTouched();
  });
}
